import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CountdownBanner() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#7B1D1D] border-t border-gold/20 py-3 px-4 shadow-[0_-4px_20px_rgba(0,0,0,0.4)]" data-id="element-34">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-35">
        <span className="text-sm sm:text-base font-semibold text-gold-light whitespace-nowrap" data-id="element-36">
          🔥 Precio de lanzamiento — últimas horas
        </span>

        <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="group inline-flex items-center gap-2 px-5 py-2.5 text-sm font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full transition-all duration-200 shadow-[0_0_20px_rgba(212,168,83,0.3)] whitespace-nowrap" data-id="element-37">
          Quiero empezar ahora
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-38" />
        </motion.a>
      </div>
    </div>;
}